export default "__VITE_ASSET__B7Xd$jvq__"